import type { IntercomUser } from "../intercom/types";

type HandoffMessage = {
  handoff?: boolean;
  intercom_user?: IntercomUser;
};

interface HandoffMessageHandlerDependencies {
  isHandoffHandled: () => boolean;
  markHandoffHandled: () => void;
  updateIntercomUser?: (intercomUser: IntercomUser) => void;
  performAdaToIntercomHandoff?: () => void;
}

const createHandoffMessageHandler = ({
  isHandoffHandled,
  markHandoffHandled,
  updateIntercomUser,
  performAdaToIntercomHandoff,
}: HandoffMessageHandlerDependencies) => {
  return (data: HandoffMessage): void => {
    if (data.intercom_user) {
      updateIntercomUser?.(data.intercom_user);
    }

    if (data.handoff === true && !isHandoffHandled()) {
      markHandoffHandled();
      performAdaToIntercomHandoff?.();
    }
  };
};

export type { IntercomUser, HandoffMessage, HandoffMessageHandlerDependencies };
export { createHandoffMessageHandler };
